type Props = {
  activeTab: 'nova' | 'meus' | 'nf' | 'feedback'
}

export function PortalPjHero({ activeTab }: Props) {
  if (activeTab === 'meus') {
    return (
      <div className='mb-2'>
        <h1 className='flex items-center gap-2 text-xl font-semibold text-white'>
          Meus chamados
        </h1>
        <p className='mt-2 text-sm leading-relaxed text-white/65'>
          Acompanhe prazos e respostas do time Rocket. Cada chamado vai para a fila interna e
          retorna aqui com atualizações de status.
        </p>
      </div>
    )
  }

  if (activeTab === 'nf') {
    return (
      <div className='mb-2'>
        <h1 className='flex items-center gap-2 text-xl font-semibold text-white'>
          Notas fiscais mensais
        </h1>
        <p className='mt-2 text-sm leading-relaxed text-white/65'>
          Anexe o PDF ou XML da NF do mês. O sistema lê número, data e CNPJ automaticamente e valida
          com seu cadastro antes de enviar ao financeiro Rocket.
        </p>
      </div>
    )
  }

  if (activeTab === 'feedback') {
    return (
      <div className='mb-2'>
        <h1 className='flex items-center gap-2 text-xl font-semibold text-white'>
          Feedback do time Rocket
        </h1>
        <p className='mt-2 text-sm leading-relaxed text-white/65'>
          Mensagens liberadas para você. Anotações internas do time não aparecem aqui.
        </p>
      </div>
    )
  }

  return (
    <header className='mb-6 rounded-3xl border border-[#e91e63]/20 bg-gradient-to-br from-[#16042d] via-[#25114d] to-[#3a073d] p-6 shadow-2xl shadow-black/20'>
      <p className='mb-3 text-xs font-bold uppercase tracking-[0.28em] text-[#e91e63]'>
        Portal RocketSearch
      </p>
      <h1 className='flex items-center gap-2 text-2xl font-black leading-tight text-white sm:text-3xl'>
        Suporte financeiro e solicitações Rocket
      </h1>
      <div className='mt-3 space-y-2 text-sm leading-relaxed text-white/70'>
        <p>
          Este é o portal para centralizar solicitações, notas fiscais, pagamentos e demandas do seu
          relacionamento com a RocketSearch.
        </p>
        <p>
          Escolha a área abaixo ou use a busca para encontrar o tipo certo de atendimento. Cada
          solicitação fica registrada com protocolo, status e prazo de resposta.
        </p>
      </div>
    </header>
  )
}
